import { styled } from '@mui/material/styles';
import { Grid, Box, Typography } from '@mui/material';

// Internal styled components with black/white theme colors
export const MetricGridContainerStyledComponent = styled(Grid)<any>(
  ({ theme, showPointer, active }: {theme: any; showPointer: boolean; active: boolean}) => ({
    cursor: showPointer ? 'pointer' : 'default',
    transition: 'all 0.3s ease', // Smooth transition
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0px 5px 24px -10px rgba(0, 0, 0, 0.1)', // Changed from blue shadow to neutral
    
    // Add thin black border matching NewAIAvatarLayout theme
    border: `1px solid ${theme.palette.primary.main}`, // Thin black border from theme
    
    // Changed blue background to black theme colors
    backgroundColor: `${active && showPointer ? 'rgb(35, 35, 35)' : theme.palette.background.paper}`,
    '&:hover': showPointer && !active
      ? {
          boxShadow: '0px 5px 40px -10px rgba(0, 0, 0, 0.15)', // Changed from blue shadow
          transform: 'scale(1.03)',
          border: `1px solid ${theme.palette.primary.dark}`, // Thin darker border on hover
        }
      : {},
  })
);

export const MetricGraphBoxContainerStyledComponent = styled(Box)<any>(
  ({ theme, hasData }) => ({
    height: '100%',
    width: '100%',
    opacity: hasData ? 1 : 0.3,
  }),
);

export const MetricGridStyledComponent = styled(Grid)<any>(
  ({ theme, isSelected }) => ({
    color: isSelected ? 'white' : theme.palette.text.primary,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }),
);

export const MetricBoxContainerStyledComponent = styled(Box)<any>(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
  }),
);

export const MetricCountTypograpgyStyledComponent = styled(Typography)<any>(
  ({ theme }) => ({
    fontWeight: 'bold',
    lineHeight: 1,
    color: 'inherit', // Inherit color from parent
  }),
);

export const MetricLabelTypograpgyStyledComponent = styled(Typography)<any>(
  ({ theme }) => ({
    lineHeight: 1.1,
    mb: 2,
    textAlign: 'center',
    textWrap: 'nowrap',
    color: 'inherit', // Inherit color from parent
  }),
);
